const __STAGING__ = process.env.NODE_ENV === 'staging';
const __DEV__ = process.env.NODE_ENV === 'development';
const __PRODUCTION__ = process.env.NODE_ENV === 'production';

export var MarketingRootURL = __DEV__ ? "http://localhost:8000" : "https://setter.io";
export const AppRootURL = __DEV__ ? "http://localhost:8002" : "https://app.setter.io";
export const APIRootURL = __DEV__ ? "http://api.lvh.me:5001/v1" : "https://api.setter-production.com/v1";

if (__STAGING__) {
  MarketingRootURL = "http://setterapp.com";
  console.warn("\n\n\nSETTER STAGING - %s\n\n\n\n", MarketingRootURL);
} else if (__DEV__) {
  console.warn("\n\n\nSETTER LOCALHOST - %s\n\n\n\n", MarketingRootURL);
} else {
  console.warn("\n\n\nSETTER PRODUCTION - %s\n\n\n\n", MarketingRootURL);
}


// let clientBaseURL = process.env.NODE_ENV === 'development' ? "http://localhost:8002" : "https://app.setter.io",
    // serverBaseURL = process.env.NODE_ENV === 'development' ? "http://api.lvh.me:5001/v1" : "https://api.setter-production.com/v1";



/** WEBPACK FOOTER **
 ** ../constants.js
 **/